// TODO AUTOMOTRIZ - JS global: buscador por tags y calculadora de financiamiento
(function () {
  function formatMXN(value) {
    var number = Number(value || 0);
    return number.toLocaleString('es-MX', {
      style: 'currency',
      currency: 'MXN',
      maximumFractionDigits: 0
    });
  }

  function initFinder(form) {
    if (!form || form.dataset.taReady === 'true') return;
    form.dataset.taReady = 'true';

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var collectionUrl = form.dataset.collectionUrl || '/collections/catalogo-de-autos';
      var selectedLabels = [];
      var fields = form.querySelectorAll('select[name]');
      var error = form.parentElement.querySelector('.ta-finder__error');

      fields.forEach(function (field) {
        if (!field.value) return;
        var option = field.options[field.selectedIndex];
        var label = option ? String(option.textContent || '').trim() : '';
        if (label) selectedLabels.push(label);
      });

      if (!selectedLabels.length) {
        if (error) error.style.display = 'block';
        return;
      }

      if (error) error.style.display = 'none';
      var query = selectedLabels.join(' · ');
      var joiner = collectionUrl.indexOf('?') >= 0 ? '&' : '?';
      window.location.href = collectionUrl.replace(/\/$/, '') + joiner + 'ta_q=' + encodeURIComponent(query);
    });
  }

  function calculatePayment(principal, annualRate, months) {
    if (!months || months <= 0) return 0;
    var monthlyRate = Number(annualRate || 0) / 100 / 12;
    if (!monthlyRate) return principal / months;
    return principal * monthlyRate / (1 - Math.pow(1 + monthlyRate, -months));
  }

  function detectVehicleYear(rawYear, productTitle) {
    var rawMatch = String(rawYear || '').trim().match(/\b(20\d{2})\b/);
    var titleMatch = String(productTitle || '').match(/\b(20\d{2})\b/);
    var value = rawMatch ? Number(rawMatch[1]) : (titleMatch ? Number(titleMatch[1]) : 0);
    return value >= 2000 && value <= 2099 ? value : 0;
  }

  function financingTerms(bankKey, year) {
    if (bankKey === 'hey') {
      if (year === 2017) return [12, 24];
      if (year === 2018) return [12, 24, 36];
      if (year === 2019) return [12, 24, 36, 48];
      if (year >= 2020 && year <= 2026) return [12, 24, 36, 48, 60];
    }
    if (bankKey === 'kuna' && year >= 2010 && year <= 2025) return [12, 24, 36, 48, 60, 72];
    if (bankKey === 'banorte') {
      if (year === 2020) return [12, 24, 36];
      if (year === 2021) return [12, 24, 36, 48];
      if (year >= 2022 && year <= 2026) return [12, 24, 36, 48, 60];
    }
    return [];
  }

  function financingRate(bankKey, downPct, kunaRate) {
    if (bankKey === 'hey') return downPct > 35 ? 13.99 : 14.99;
    if (bankKey === 'banorte') return downPct >= 40 ? 14.99 : 16.49;
    if (bankKey === 'kuna') return kunaRate;
    return 0;
  }

  function initFinanceCard(card) {
    if (!card || card.dataset.taReady === 'true') return;
    card.dataset.taReady = 'true';

    var price = Number(card.dataset.price || 0);
    var year = detectVehicleYear(card.dataset.productYear, card.dataset.productTitle);
    var kunaRate = Number(card.dataset.kunaRate || 14.5);
    if (!isFinite(kunaRate) || kunaRate < 0) kunaRate = 14.5;

    var banks = [
      { key: 'hey', label: 'HEY Banco' },
      { key: 'kuna', label: 'KUNA' },
      { key: 'banorte', label: 'Banorte' }
    ];
    var selectedBank = banks.find(function (item) {
      return financingTerms(item.key, year).length > 0;
    });

    if (!price || !year || !selectedBank) {
      card.hidden = true;
      return;
    }

    var terms = financingTerms(selectedBank.key, year);
    var downPct = 30;
    var months = terms[terms.length - 1];
    var annualRate = financingRate(selectedBank.key, downPct, kunaRate);
    var principal = price * (1 - downPct / 100);
    var monthly = calculatePayment(principal, annualRate, months);
    var monthlyNode = card.querySelector('[data-ta-finance-card-monthly]');
    var scenarioNode = card.querySelector('[data-ta-finance-card-scenario]');

    if (monthlyNode) monthlyNode.innerHTML = formatMXN(monthly) + ' <span>MXN/mensuales*</span>';
    if (scenarioNode) scenarioNode.textContent = selectedBank.label + ' · ' + downPct + '% · ' + months + ' meses';
  }

  function detailIcon(type) {
    var icons = {
      car: '<svg viewBox="0 0 24 24" fill="none"><path d="M4 14V11l2-5h12l2 5v3M6 14h12M7 17h.01M17 17h.01M6 18h12a1 1 0 0 0 1-1v-3H5v3a1 1 0 0 0 1 1Z" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      gauge: '<svg viewBox="0 0 24 24" fill="none"><path d="M5 17a8 8 0 1 1 14 0M12 13l4-4M8 17h8" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      money: '<svg viewBox="0 0 24 24" fill="none"><path d="M4 7h16v10H4zM8 12h.01M16 12h.01M12 9.5v5M13.5 10.5c-.4-.7-2.4-.7-2.8.2-.5 1.3 3.1 1.2 2.6 2.6-.4.9-2.4.9-2.9.2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      engine: '<svg viewBox="0 0 24 24" fill="none"><path d="M7 8h9l2 2v6l-2 2H8l-2-2H4v-5h2l1-3ZM9 5h5M11 5v3M18 12h2v3" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      shield: '<svg viewBox="0 0 24 24" fill="none"><path d="m12 3 7 3v5c0 4.5-2.8 8-7 10-4.2-2-7-5.5-7-10V6l7-3Z" stroke="currentColor" stroke-width="1.7"/><path d="m9 12 2 2 4-4" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      document: '<svg viewBox="0 0 24 24" fill="none"><path d="M6 3h8l4 4v14H6zM14 3v5h4M9 12h6M9 16h6" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      key: '<svg viewBox="0 0 24 24" fill="none"><circle cx="8" cy="12" r="4" stroke="currentColor" stroke-width="1.7"/><path d="M12 12h9M17 12v3M20 12v2" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      card: '<svg viewBox="0 0 24 24" fill="none"><rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" stroke-width="1.7"/><path d="M3 10h18M7 15h4" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>',
      comfort: '<svg viewBox="0 0 24 24" fill="none"><path d="M7 12V7a3 3 0 0 1 6 0v5M5 12h12a2 2 0 0 1 2 2v5H5v-7ZM8 19v2M16 19v2" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      check: '<svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.7"/><path d="m8 12 2.6 2.6L16.5 9" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>'
    };
    return icons[type] || icons.check;
  }

  function detailType(text) {
    var value = String(text || '').toLowerCase();
    if (/kilomet|km\b|od[oó]metro/.test(value)) return 'gauge';
    if (/precio|\$|costo|enganche|mensual/.test(value)) return 'money';
    if (/motor|potencia|hp\b|cilind|transmisi|velocid/.test(value)) return 'engine';
    if (/freno|abs\b|bolsa|airbag|alarma|isofix|latch|seguridad/.test(value)) return 'shield';
    if (/factura|tenencia|verificaci|document|pago[s]? al/.test(value)) return 'document';
    if (/llave|keyless/.test(value)) return 'key';
    if (/tarjeta|cr[eé]dito|comisi[oó]n/.test(value)) return 'card';
    if (/aire|asiento|tapicer|confort|clima|audio|pantalla/.test(value)) return 'comfort';
    if (/marca|modelo|año|auto|veh[ií]culo/.test(value)) return 'car';
    return 'check';
  }

  function initDetailDescription(source) {
    if (!source || source.dataset.taReady === 'true') return;
    source.dataset.taReady = 'true';

    var rawLines = String(source.innerText || source.textContent || '')
      .split(/\n+/)
      .map(function (line) { return line.replace(/^[\s•·▪◦\-]+/, '').trim(); })
      .filter(function (line) { return line && line !== '.' && line !== '•' && line !== '·'; });
    var lines = rawLines.filter(function (line, index) { return index === 0 || line !== rawLines[index - 1]; });
    if (!lines.length) return;

    var title = String(source.dataset.productTitle || '').trim();
    var layout = document.createElement('div');
    layout.className = 'ta-detail-layout';

    var hero = document.createElement('div');
    hero.className = 'ta-detail-hero';
    hero.innerHTML = '<span class="ta-detail-hero__icon">' + detailIcon('car') + '</span><div class="ta-detail-hero__copy"><span class="ta-detail-hero__eyebrow">Información del vehículo</span><h2></h2></div>';
    hero.querySelector('h2').textContent = title || 'Detalles del auto';

    var detailInterestButton = document.createElement('button');
    detailInterestButton.type = 'button';
    detailInterestButton.className = 'ta-auto-product__interest-button ta-detail-interest-button';
    detailInterestButton.setAttribute('aria-label', 'Estoy interesado en ' + (title || 'este vehículo') + '. Abrir WhatsApp');
    detailInterestButton.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M20.5 11.7a8.5 8.5 0 0 1-12.6 7.4L3 20.4l1.3-4.7a8.5 8.5 0 1 1 16.2-4Z" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"></path><path d="M8.2 7.7c.2-.4.4-.4.7-.4h.5c.2 0 .3.1.4.4l.8 2c.1.3.1.5-.1.7l-.6.7c-.2.2-.1.4 0 .6.6 1.2 1.6 2.1 2.8 2.7.2.1.4.1.6-.1l.8-1c.2-.2.4-.3.7-.2l1.9.9c.3.1.4.3.4.5 0 .5-.2 1.5-.9 2-.6.5-1.5.8-2.4.6-1.1-.2-2.6-.7-4.4-2.3-1.5-1.3-2.5-2.9-2.8-4-.3-.9 0-2.1.4-2.7.3-.3.7-.4 1.2-.4Z" fill="currentColor"></path></svg><span>Estoy interesado</span><b aria-hidden="true">↗</b>';
    detailInterestButton.addEventListener('click', function () {
      var message = 'Hola TodoAutomotriz, estoy interesado en el vehículo: ' + (title || 'este vehículo') + '. ¿Me pueden compartir más información?';
      window.open('https://wa.me/525527044169?text=' + encodeURIComponent(message), '_blank', 'noopener,noreferrer');
    });
    hero.appendChild(detailInterestButton);
    layout.appendChild(hero);

    var links = [];
    var groups = [];
    var current = { title: 'Resumen', items: [] };
    groups.push(current);

    lines.forEach(function (line) {
      var urlMatch = line.match(/https?:\/\/[^\s]+/i);
      if (urlMatch) {
        links.push({ url: urlMatch[0], label: line.replace(urlMatch[0], '').trim() || 'Visitar sitio web' });
        return;
      }

      var clean = line.replace(/\*+$/g, '').trim();
      if (!clean) return;
      var isSection = /:$/.test(clean) && clean.indexOf(':') === clean.length - 1 && clean.length < 65;
      if (isSection) {
        current = { title: clean.replace(/:$/, ''), items: [] };
        groups.push(current);
        return;
      }

      var label = '';
      var value = clean;
      var pair = clean.match(/^([^:]{2,42}):\s*(.+)$/);
      if (pair) {
        label = pair[1].trim();
        value = pair[2].trim();
      }

      var normalizedTitle = title.toLowerCase().replace(/\s+/g, ' ');
      if (normalizedTitle && clean.toLowerCase().replace(/\s+/g, ' ') === normalizedTitle) return;
      current.items.push({ label: label, value: value, type: detailType(clean) });
    });

    groups.filter(function (group) { return group.items.length; }).forEach(function (group) {
      var section = document.createElement('section');
      section.className = 'ta-detail-section';
      var heading = document.createElement('h3');
      heading.textContent = group.title;
      section.appendChild(heading);
      var grid = document.createElement('div');
      grid.className = 'ta-detail-grid';

      group.items.forEach(function (item) {
        var card = document.createElement('article');
        card.className = 'ta-detail-item ta-detail-item--' + item.type;
        card.innerHTML = '<span class="ta-detail-item__icon">' + detailIcon(item.type) + '</span><div class="ta-detail-item__copy"></div>';
        var copy = card.querySelector('.ta-detail-item__copy');
        if (item.label) {
          var label = document.createElement('span');
          label.className = 'ta-detail-item__label';
          label.textContent = item.label;
          copy.appendChild(label);
        }
        var value = document.createElement('span');
        value.className = 'ta-detail-item__value';
        value.textContent = item.value;
        copy.appendChild(value);
        grid.appendChild(card);
      });
      section.appendChild(grid);
      layout.appendChild(section);
    });

    if (links.length) {
      var linkRow = document.createElement('div');
      linkRow.className = 'ta-detail-links';
      links.forEach(function (item) {
        var link = document.createElement('a');
        link.href = item.url;
        link.target = '_blank';
        link.rel = 'noopener';
        link.innerHTML = '<span>' + detailIcon('car') + '</span><strong></strong><b aria-hidden="true">↗</b>';
        link.querySelector('strong').textContent = item.label;
        linkRow.appendChild(link);
      });
      layout.appendChild(linkRow);
    }

    if (!layout.querySelector('.ta-detail-item') && !links.length) return;
    source.insertAdjacentElement('afterend', layout);
    source.classList.add('ta-detail-source--enhanced');
  }

  function initCardFavorite(button) {
    if (!button || button.dataset.taReady === 'true') return;
    button.dataset.taReady = 'true';
    var productId = String(button.dataset.productId || '');
    if (!productId) return;
    var storageKey = 'ta-favorite-autos';

    function readFavorites() {
      try {
        var value = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
        return Array.isArray(value) ? value.map(String) : [];
      } catch (error) {
        return [];
      }
    }

    function paint(active) {
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    }

    paint(readFavorites().indexOf(productId) >= 0);
    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      var favorites = readFavorites();
      var index = favorites.indexOf(productId);
      if (index >= 0) favorites.splice(index, 1);
      else favorites.push(productId);
      try { window.localStorage.setItem(storageKey, JSON.stringify(favorites)); } catch (error) {}
      paint(index < 0);
    });
  }

  function initCreditCalculator(widget) {
    if (!widget || widget.dataset.taReady === 'true') return;
    widget.dataset.taReady = 'true';

    var price = Number(widget.dataset.price || 0);
    var detectedYear = detectVehicleYear(widget.dataset.productYear, widget.dataset.productTitle);
    var kunaRate = Number(widget.dataset.kunaRate || 14.5);
    if (!isFinite(kunaRate) || kunaRate < 0) kunaRate = 14.5;

    var bank = widget.querySelector('.ta-credit-bank');
    var yearField = widget.querySelector('.ta-credit-year');
    var downpayment = widget.querySelector('.ta-credit-downpayment');
    var term = widget.querySelector('.ta-credit-term');
    var rate = widget.querySelector('.ta-credit-rate');
    var result = widget.querySelector('.ta-credit-result');
    var financedAmount = widget.querySelector('.ta-credit-financed-amount');
    var downpaymentAmount = widget.querySelector('.ta-credit-downpayment-amount');
    var bankNote = widget.querySelector('[data-ta-credit-bank-note]');
    var unavailable = widget.querySelector('[data-ta-credit-unavailable]');

    var BANKS = {
      hey: {
        label: 'HEY Banco',
        years: [2017, 2026],
        downpayments: [20, 30, 35, 40, 50, 60, 70]
      },
      kuna: {
        label: 'KUNA',
        years: [2010, 2025],
        downpayments: [15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70]
      },
      banorte: {
        label: 'Banorte',
        years: [2020, 2026],
        downpayments: [20, 30, 39, 40, 50, 60, 70]
      }
    };

    function getTerms(bankKey, year) {
      return financingTerms(bankKey, year);
    }

    function getAnnualRate(bankKey, downPct) {
      return financingRate(bankKey, downPct, kunaRate);
    }

    function setOptions(select, values, formatter, preferred) {
      if (!select) return;
      var previous = Number(select.value || preferred || 0);
      select.innerHTML = '';
      values.forEach(function (value) {
        var option = document.createElement('option');
        option.value = String(value);
        option.textContent = formatter(value);
        select.appendChild(option);
      });
      var selected = values.indexOf(previous) >= 0 ? previous : preferred;
      if (values.indexOf(selected) < 0) selected = values[values.length - 1];
      if (selected != null) select.value = String(selected);
    }

    function setUnavailable(message) {
      widget.classList.add('is-unavailable');
      if (bank) {
        bank.innerHTML = '<option value="">Sin bancos disponibles</option>';
        bank.disabled = true;
      }
      if (downpayment) {
        downpayment.innerHTML = '';
        downpayment.disabled = true;
      }
      if (term) {
        term.innerHTML = '';
        term.disabled = true;
      }
      if (rate) rate.value = '—';
      if (bankNote) bankNote.textContent = '';
      if (unavailable) {
        unavailable.hidden = false;
        unavailable.textContent = message;
      }
      if (result) result.textContent = 'No disponible';
      if (financedAmount) financedAmount.textContent = '—';
      if (downpaymentAmount) downpaymentAmount.textContent = '—';
    }

    function refresh() {
      if (!bank || !bank.value || !downpayment || !term) return;
      var bankKey = bank.value;
      var downPct = Number(downpayment.value || 0);
      var months = Number(term.value || 0);
      var annualRate = getAnnualRate(bankKey, downPct);
      var down = price * (downPct / 100);
      var principal = Math.max(price - down, 0);
      var monthly = calculatePayment(principal, annualRate, months);

      if (rate) rate.value = annualRate.toFixed(2).replace(/\.00$/, '') + '%';
      if (result) result.textContent = formatMXN(monthly) + ' MXN';
      if (financedAmount) financedAmount.textContent = formatMXN(principal);
      if (downpaymentAmount) downpaymentAmount.textContent = formatMXN(down);

      if (bankNote) {
        if (bankKey === 'hey') {
          bankNote.textContent = 'HEY Banco: 14.99% con enganche de hasta 35%; 13.99% con enganche mayor a 35%.';
        } else if (bankKey === 'banorte') {
          bankNote.textContent = 'Banorte: 16.49% con enganche de hasta 39%; 14.99% desde 40% de enganche.';
        } else {
          bankNote.textContent = 'KUNA: tasa anual referencial sujeta a evaluación y aprobación.';
        }
      }
    }

    function configureBank() {
      if (!bank || !bank.value || !BANKS[bank.value]) return;
      var bankKey = bank.value;
      var rules = BANKS[bankKey];
      var terms = getTerms(bankKey, detectedYear);
      setOptions(downpayment, rules.downpayments, function (value) { return value + '%'; }, 30);
      setOptions(term, terms, function (value) { return value + ' meses'; }, terms[terms.length - 1]);
      if (downpayment) downpayment.disabled = false;
      if (term) term.disabled = false;
      refresh();
    }

    if (yearField) yearField.value = detectedYear ? String(detectedYear) : '';

    if (!detectedYear) {
      setUnavailable('No pudimos detectar el año del auto. Agrégalo en el metafield custom.anio_modelo o inclúyelo en el título.');
      return;
    }

    var availableBanks = Object.keys(BANKS).filter(function (bankKey) {
      return getTerms(bankKey, detectedYear).length > 0;
    });

    if (!availableBanks.length) {
      setUnavailable('No existen opciones bancarias configuradas para un modelo ' + detectedYear + '.');
      return;
    }

    widget.classList.remove('is-unavailable');
    if (unavailable) unavailable.hidden = true;
    if (bank) {
      bank.innerHTML = '';
      availableBanks.forEach(function (bankKey) {
        var option = document.createElement('option');
        option.value = bankKey;
        option.textContent = BANKS[bankKey].label;
        bank.appendChild(option);
      });
      bank.disabled = false;
      bank.addEventListener('change', configureBank);
    }

    ['change', 'input'].forEach(function (eventName) {
      if (downpayment) downpayment.addEventListener(eventName, refresh);
      if (term) term.addEventListener(eventName, refresh);
    });

    configureBank();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ta-finder__form').forEach(initFinder);
    document.querySelectorAll('[data-ta-finance-card]').forEach(initFinanceCard);
    document.querySelectorAll('[data-ta-detail-description]').forEach(initDetailDescription);
    document.querySelectorAll('[data-ta-card-favorite]').forEach(initCardFavorite);
    document.querySelectorAll('.ta-credit-calculator').forEach(initCreditCalculator);

    if (window.MutationObserver && document.body) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (!node || node.nodeType !== 1) return;
            if (node.matches && node.matches('[data-ta-card-favorite]')) initCardFavorite(node);
            if (node.matches && node.matches('[data-ta-finance-card]')) initFinanceCard(node);
            if (node.querySelectorAll) {
              node.querySelectorAll('[data-ta-card-favorite]').forEach(initCardFavorite);
              node.querySelectorAll('[data-ta-finance-card]').forEach(initFinanceCard);
            }
          });
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  });
})();


/* TODO AUTOMOTRIZ V9 - Galería vertical para página de producto */
(function () {
  function initAutoGallery(gallery) {
    if (!gallery || gallery.dataset.taReady === 'true') return;
    gallery.dataset.taReady = 'true';

    var root = gallery.closest('.ta-auto-product');
    if (!root) return;

    var images = Array.prototype.slice.call(root.querySelectorAll('[data-ta-main-image]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ta-thumb]'));
    var track = root.querySelector('[data-ta-thumbs]');
    var current = 0;

    if (!images.length) return;

    function show(index) {
      var total = images.length;
      current = ((index % total) + total) % total;

      images.forEach(function (img, idx) {
        img.classList.toggle('is-active', idx === current);
      });

      thumbs.forEach(function (thumb, idx) {
        thumb.classList.toggle('is-active', idx === current);
        if (idx === current && typeof thumb.scrollIntoView === 'function') {
          thumb.scrollIntoView({ block: 'center', inline: 'center', behavior: 'smooth' });
        }
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        show(Number(thumb.dataset.taThumb || 0));
      });
    });

    root.querySelectorAll('[data-ta-gallery-nav]').forEach(function (button) {
      button.addEventListener('click', function () {
        show(current + (button.dataset.taGalleryNav === 'next' ? 1 : -1));
      });
    });

    root.querySelectorAll('[data-ta-gallery-scroll]').forEach(function (button) {
      button.addEventListener('click', function () {
        var direction = button.dataset.taGalleryScroll === 'down' ? 1 : -1;
        show(current + direction);
      });
    });

    show(0);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-ta-gallery]').forEach(initAutoGallery);
  });

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-ta-gallery]').forEach(initAutoGallery);
  });
})();

/* TODO AUTOMOTRIZ V13 - Hero search modal + catalog client filter */
(function () {
  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  function terms(value) {
    return normalize(value).split(/\s+/).filter(Boolean);
  }

  function buildCatalogUrl(base, query) {
    var url = base || '/collections/catalogo-de-autos';
    var joiner = url.indexOf('?') >= 0 ? '&' : '?';
    if (!query) return url;
    return url + joiner + 'ta_q=' + encodeURIComponent(query);
  }

  function readProducts(root) {
    var script = root.querySelector('[data-ta-products-json]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent || '[]') || [];
    } catch (e) {
      return [];
    }
  }

  function initHeroSearch(root) {
    if (!root || root.dataset.taHeroReady === 'true') return;
    root.dataset.taHeroReady = 'true';

    var modal = root.querySelector('[data-ta-search-modal]');
    var input = root.querySelector('[data-ta-modal-input]');
    var results = root.querySelector('[data-ta-search-results]');
    var popular = root.querySelector('[data-ta-popular-searches]');
    var label = root.querySelector('[data-ta-modal-label]');
    var form = root.querySelector('[data-ta-search-form]');
    var catalogUrl = root.dataset.catalogUrl || '/collections/catalogo-de-autos';
    var products = readProducts(root);

    function openModal(event) {
      if (!modal) return;
      var trigger = event && event.currentTarget ? event.currentTarget : null;
      if (trigger && trigger.getBoundingClientRect) {
        var rect = trigger.getBoundingClientRect();
        var dialogApproxHeight = window.innerWidth < 750 ? 250 : 270;
        var minTop = window.innerWidth < 750 ? 72 : 92;
        var maxTop = Math.max(minTop, window.innerHeight - dialogApproxHeight - 28);
        var top = rect.top + (rect.height / 2) - (dialogApproxHeight / 2);
        top = Math.min(Math.max(minTop, top), maxTop);
        modal.style.setProperty('--ta-search-modal-top', Math.round(top) + 'px');
      }
      modal.hidden = false;
      requestAnimationFrame(function () {
        modal.classList.add('is-active');
        if (input) input.focus();
      });
      render('');
    }

    function closeModal() {
      if (!modal) return;
      modal.classList.remove('is-active');
      window.setTimeout(function () { modal.hidden = true; }, 180);
    }

    function go(query) {
      window.location.href = buildCatalogUrl(catalogUrl, query || (input && input.value));
    }

    function matches(product, valueTerms) {
      var haystack = normalize((product.title || '') + ' ' + (product.search || ''));
      return valueTerms.every(function (term) { return haystack.indexOf(term) >= 0; });
    }

    function render(value) {
      if (!results) return;
      var q = normalize(value);
      var qTerms = terms(q);

      if (!qTerms.length) {
        if (popular) popular.style.display = '';
        if (label) label.textContent = 'Búsquedas populares';
        results.innerHTML = '';
        return;
      }

      if (popular) popular.style.display = 'none';
      var found = products.filter(function (product) { return matches(product, qTerms); }).slice(0, 10);
      if (label) label.textContent = found.length ? 'Resultados' : 'Sin resultados directos';

      if (!found.length) {
        results.innerHTML = '<button type="button" class="ta-search-modal__result ta-search-modal__result--empty" data-ta-go-query="' + q.replace(/"/g, '&quot;') + '">Buscar “' + q + '” en catálogo</button>';
        return;
      }

      results.innerHTML = found.map(function (product) {
        var title = String(product.title || 'Auto disponible');
        var state = product.available ? 'Disponible' : 'Vendido';
        return '<a class="ta-search-modal__result" href="' + buildCatalogUrl(catalogUrl, title) + '">' +
          '<span class="ta-search-modal__arrow">→</span>' +
          '<span><strong>' + title.replace(/</g, '&lt;') + '</strong><small>' + state + (product.price ? ' · ' + product.price : '') + '</small></span>' +
          '</a>';
      }).join('');
    }

    root.querySelectorAll('[data-ta-open-search]').forEach(function (button) {
      button.addEventListener('click', openModal);
    });

    root.querySelectorAll('[data-ta-close-search]').forEach(function (button) {
      button.addEventListener('click', closeModal);
    });

    if (input) {
      input.addEventListener('input', function () { render(input.value); });
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        go(input && input.value);
      });
    }

    if (popular) {
      popular.addEventListener('click', function (event) {
        var btn = event.target.closest('[data-ta-popular]');
        if (!btn) return;
        go(btn.dataset.taPopular || btn.textContent);
      });
    }

    if (results) {
      results.addEventListener('click', function (event) {
        var btn = event.target.closest('[data-ta-go-query]');
        if (!btn) return;
        go(btn.dataset.taGoQuery || '');
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal && modal.classList.contains('is-active')) closeModal();
    });
  }

  function initCatalogSearch(root) {
    if (!root || root.dataset.taCatalogReady === 'true') return;
    root.dataset.taCatalogReady = 'true';

    var input = root.querySelector('[data-ta-catalog-input]');
    var form = root.querySelector('[data-ta-catalog-form]');
    var count = root.querySelector('[data-ta-catalog-count]');
    var empty = document.querySelector('[data-ta-catalog-empty]');
    var cards = Array.prototype.slice.call(document.querySelectorAll('[data-ta-catalog-card]'));

    function searchGroups(value) {
      var chunks = String(value || '')
        .split(/[|·]/)
        .map(function (part) { return String(part || '').trim(); })
        .filter(Boolean);

      var priceAliases = {
        'menor a $250,000': ['precio-menor-250'],
        '$250,000 a $400,000': ['precio-250-400'],
        '$400,000 a $600,000': ['precio-400-600'],
        'mayor a $600,000': ['precio-mayor-600']
      };

      return chunks.map(function (chunk) {
        var key = normalize(chunk);
        if (priceAliases[key]) return priceAliases[key];
        return terms(chunk);
      }).filter(function (group) { return group.length; });
    }

    function cardMatches(card, groups) {
      if (!groups.length) return true;
      var haystack = normalize((card.dataset.taSearch || '') + ' ' + (card.dataset.taProductTitle || ''));
      return groups.every(function (groupTerms) {
        return groupTerms.every(function (term) { return haystack.indexOf(term) >= 0; });
      });
    }

    function apply(value, updateUrl) {
      var groups = searchGroups(value);
      var visible = 0;

      cards.forEach(function (card) {
        var show = cardMatches(card, groups);

        /*
          En catálogo tenemos reglas con display:flex !important para igualar los cards al home.
          Eso puede ganarle al atributo hidden del navegador, por eso forzamos el display
          directamente cuando el buscador filtra.
        */
        if (show) {
          card.hidden = false;
          card.classList.remove('ta-catalog-card--hidden');
          card.style.removeProperty('display');
          visible += 1;
        } else {
          card.hidden = true;
          card.classList.add('ta-catalog-card--hidden');
          card.style.setProperty('display', 'none', 'important');
        }
      });

      if (count) {
        count.textContent = groups.length ? (visible + ' resultado(s) para “' + value + '”') : (cards.length + ' auto(s) en catálogo');
      }

      var desktopProductCount = document.getElementById('ProductCountDesktop');
      if (desktopProductCount) {
        desktopProductCount.textContent = groups.length ? (visible + ' producto(s) filtrado(s)') : (cards.length + ' productos');
      }
      if (empty) empty.hidden = visible !== 0;

      if (updateUrl && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        if (groups.length) url.searchParams.set('ta_q', value);
        else url.searchParams.delete('ta_q');
        window.history.replaceState({}, '', url.toString());
      }
    }

    if (input) {
      var params = new URLSearchParams(window.location.search);
      var initial = params.get('ta_q') || params.get('q') || '';
      if (initial) input.value = initial;
      apply(input.value, false);
      input.addEventListener('input', function () { apply(input.value, true); });
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        apply(input && input.value, true);
      });
    }

    root.querySelectorAll('[data-ta-catalog-chip]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        if (input) input.value = chip.dataset.taCatalogChip || chip.textContent;
        apply(input && input.value, true);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-ta-hero-search]').forEach(initHeroSearch);
    document.querySelectorAll('[data-ta-catalog-search]').forEach(initCatalogSearch);
  });

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-ta-hero-search]').forEach(initHeroSearch);
    event.target.querySelectorAll('[data-ta-catalog-search]').forEach(initCatalogSearch);
  });
})();


/* TODO AUTOMOTRIZ V62 - Popup de sucursal con Google Maps */
(function () {
  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  function parseConfig() {
    var script = document.querySelector('[data-ta-branch-config]');
    if (!script) return { branches: [] };
    try {
      return JSON.parse(script.textContent || '{}') || { branches: [] };
    } catch (e) {
      return { branches: [] };
    }
  }

  function findBranch(locationName, config) {
    var location = normalize(locationName);
    var branches = (config && config.branches) || [];
    var fallback = null;

    branches.forEach(function (branch) {
      if (!fallback && branch && branch.name) fallback = branch;
    });

    for (var i = 0; i < branches.length; i += 1) {
      var branch = branches[i];
      if (!branch) continue;
      var name = normalize(branch.name);
      var key = normalize(branch.key);
      var aliases = (branch.aliases || []).map(normalize);
      var candidates = [name, key].concat(aliases).filter(Boolean);
      for (var j = 0; j < candidates.length; j += 1) {
        var c = candidates[j];
        if (location.indexOf(c) >= 0 || c.indexOf(location) >= 0) return branch;
      }
    }

    if (location.indexOf('xochimilco') >= 0) {
      return branches.find(function (b) { return normalize(b.key).indexOf('xochimilco') >= 0; }) || fallback;
    }
    if (location.indexOf('tlalne') >= 0 || location.indexOf('tlane') >= 0) {
      return branches.find(function (b) { return normalize(b.key).indexOf('tlalnepantla') >= 0; }) || fallback;
    }

    return fallback || { name: locationName || 'Sucursal', address: '' };
  }

  function initBranchModal() {
    var modal = document.querySelector('[data-ta-branch-modal]');
    if (!modal || modal.dataset.taReady === 'true') return;
    modal.dataset.taReady = 'true';

    var config = parseConfig();
    var productLink = modal.querySelector('[data-ta-branch-product-link]');
    var imageWrap = modal.querySelector('[data-ta-branch-image-wrap]');
    var image = modal.querySelector('[data-ta-branch-image]');
    var title = modal.querySelector('[data-ta-branch-title]');
    var subtitle = modal.querySelector('[data-ta-branch-subtitle]');
    var locationEl = modal.querySelector('[data-ta-branch-location]');
    var addressEl = modal.querySelector('[data-ta-branch-address]');
    var iframe = modal.querySelector('[data-ta-branch-map]');

    function open(trigger) {
      var locationName = trigger.dataset.taBranchName || 'Sucursal';
      var branch = findBranch(locationName, config);
      var address = branch.address || '';
      var branchName = branch.name || locationName;
      var productUrl = trigger.dataset.taProductUrl || '#';
      var productTitle = trigger.dataset.taProductTitle || 'Auto disponible';
      var productSubtitle = trigger.dataset.taProductSubtitle || '';
      var productImage = trigger.dataset.taProductImage || '';

      if (productLink) productLink.href = productUrl;
      if (title) title.textContent = productTitle;
      if (subtitle) {
        subtitle.textContent = productSubtitle;
        subtitle.style.display = productSubtitle ? '' : 'none';
      }
      if (locationEl) locationEl.textContent = branchName;
      if (addressEl) addressEl.textContent = address;

      if (image && imageWrap) {
        if (productImage) {
          image.src = productImage;
          image.alt = productTitle;
          imageWrap.classList.remove('is-empty');
        } else {
          image.removeAttribute('src');
          image.alt = '';
          imageWrap.classList.add('is-empty');
        }
      }

      if (iframe) {
        var query = address || branchName || locationName;
        iframe.src = 'https://www.google.com/maps?q=' + encodeURIComponent(query) + '&output=embed';
      }

      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ta-branch-modal-open');
      window.setTimeout(function () {
        var close = modal.querySelector('[data-ta-branch-close]');
        if (close && close.focus) close.focus();
      }, 40);
    }

    function close() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ta-branch-modal-open');
      if (iframe) iframe.src = 'about:blank';
    }

    function handleBranchClick(event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var trigger = target.closest('[data-ta-branch-trigger]');
      if (trigger) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        open(trigger);
        return false;
      }

      if (target.closest('[data-ta-branch-close]')) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        close();
        return false;
      }
    }

    /* Capture=true para ganarle al overlay/link general del card de Dawn. */
    document.addEventListener('click', handleBranchClick, true);

    document.addEventListener('keydown', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var trigger = target.closest('[data-ta-branch-trigger]');
      if (trigger && (event.key === 'Enter' || event.key === ' ' || event.code === 'Space')) {
        event.preventDefault();
        event.stopPropagation();
        open(trigger);
      }
    }, true);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) close();
    });
  }

  document.addEventListener('DOMContentLoaded', initBranchModal);
  document.addEventListener('shopify:section:load', initBranchModal);
})();

/* TODO AUTOMOTRIZ V64 - Listener robusto para sucursal/mapa */
(function () {
  if (window.__taBranchModalV64) return;
  window.__taBranchModalV64 = true;

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  function parseConfig() {
    var script = document.querySelector('[data-ta-branch-config]');
    if (!script) return { branches: [] };
    try { return JSON.parse(script.textContent || '{}') || { branches: [] }; }
    catch (e) { return { branches: [] }; }
  }

  function findBranch(locationName) {
    var config = parseConfig();
    var location = normalize(locationName);
    var branches = (config && config.branches) || [];
    var fallback = branches[0] || { name: locationName || 'Sucursal', address: '' };

    for (var i = 0; i < branches.length; i += 1) {
      var branch = branches[i] || {};
      var candidates = [branch.name, branch.key].concat(branch.aliases || []).map(normalize).filter(Boolean);
      for (var j = 0; j < candidates.length; j += 1) {
        var c = candidates[j];
        if (location.indexOf(c) >= 0 || c.indexOf(location) >= 0) return branch;
      }
    }

    if (location.indexOf('xochimilco') >= 0) {
      return branches.find(function (b) { return normalize(b.key).indexOf('xochimilco') >= 0; }) || fallback;
    }
    if (location.indexOf('tlalne') >= 0 || location.indexOf('tlane') >= 0) {
      return branches.find(function (b) { return normalize(b.key).indexOf('tlalnepantla') >= 0; }) || fallback;
    }
    return fallback;
  }

  function getModal() {
    var modal = document.querySelector('[data-ta-branch-modal]');
    if (!modal) return null;
    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }
    return modal;
  }

  function triggerFromPoint(event) {
    if (!event || typeof event.clientX !== 'number') return null;
    var triggers = document.querySelectorAll('[data-ta-branch-trigger]');
    for (var i = 0; i < triggers.length; i += 1) {
      var el = triggers[i];
      var r = el.getBoundingClientRect();
      if (event.clientX >= r.left && event.clientX <= r.right && event.clientY >= r.top && event.clientY <= r.bottom) {
        return el;
      }
    }
    return null;
  }

  function findTrigger(event) {
    var target = event && event.target;
    if (target && target.closest) {
      var direct = target.closest('[data-ta-branch-trigger]');
      if (direct) return direct;
    }
    return triggerFromPoint(event);
  }

  function openModal(trigger) {
    var modal = getModal();
    if (!modal || !trigger) return;

    var branch = findBranch(trigger.getAttribute('data-ta-branch-name') || 'Sucursal');
    var branchName = branch.name || trigger.getAttribute('data-ta-branch-name') || 'Sucursal';
    var address = branch.address || '';
    var productUrl = trigger.getAttribute('data-ta-product-url') || '#';
    var productTitle = trigger.getAttribute('data-ta-product-title') || 'Auto disponible';
    var productSubtitle = trigger.getAttribute('data-ta-product-subtitle') || '';
    var productImage = trigger.getAttribute('data-ta-product-image') || '';

    var productLink = modal.querySelector('[data-ta-branch-product-link]');
    var imageWrap = modal.querySelector('[data-ta-branch-image-wrap]');
    var image = modal.querySelector('[data-ta-branch-image]');
    var title = modal.querySelector('[data-ta-branch-title]');
    var subtitle = modal.querySelector('[data-ta-branch-subtitle]');
    var locationEl = modal.querySelector('[data-ta-branch-location]');
    var addressEl = modal.querySelector('[data-ta-branch-address]');
    var iframe = modal.querySelector('[data-ta-branch-map]');

    if (productLink) productLink.setAttribute('href', productUrl);
    if (title) title.textContent = productTitle;
    if (subtitle) {
      subtitle.textContent = productSubtitle;
      subtitle.style.display = productSubtitle ? '' : 'none';
    }
    if (locationEl) locationEl.textContent = branchName;
    if (addressEl) addressEl.textContent = address;

    if (image && imageWrap) {
      if (productImage) {
        image.setAttribute('src', productImage);
        image.setAttribute('alt', productTitle);
        imageWrap.classList.remove('is-empty');
      } else {
        image.removeAttribute('src');
        image.setAttribute('alt', '');
        imageWrap.classList.add('is-empty');
      }
    }

    if (iframe) {
      var query = address || branchName || trigger.getAttribute('data-ta-branch-name') || 'Sucursal';
      iframe.setAttribute('src', 'https://www.google.com/maps?q=' + encodeURIComponent(query) + '&output=embed');
    }

    modal.hidden = false;
    modal.removeAttribute('hidden');
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    document.body.classList.add('ta-branch-modal-open');
  }

  function closeModal() {
    var modal = getModal();
    if (!modal) return;
    var iframe = modal.querySelector('[data-ta-branch-map]');
    if (iframe) iframe.setAttribute('src', 'about:blank');
    modal.hidden = true;
    modal.setAttribute('hidden', 'hidden');
    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove('is-open');
    document.body.classList.remove('ta-branch-modal-open');
  }

  function intercept(event) {
    var target = event.target;
    if (target && target.closest && target.closest('[data-ta-branch-close]')) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      closeModal();
      return false;
    }

    var trigger = findTrigger(event);
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    openModal(trigger);
    return false;
  }

  document.addEventListener('click', intercept, true);
  document.addEventListener('mousedown', function (event) {
    var trigger = findTrigger(event);
    if (trigger) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeModal();
    var target = event.target;
    if (!target || !target.closest) return;
    var trigger = target.closest('[data-ta-branch-trigger]');
    if (trigger && (event.key === 'Enter' || event.key === ' ' || event.code === 'Space')) {
      event.preventDefault();
      openModal(trigger);
    }
  }, true);
})();

/* V74 - Tabs de sucursales en Inicio sin modificar index.json ni eliminar secciones */
(function () {
  function esc(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function makeMapsUrl(address) {
    return 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(address);
  }

  function makeEmbedUrl(address) {
    return 'https://www.google.com/maps?q=' + encodeURIComponent(address) + '&output=embed';
  }

  function initHomeBranchTabs() {
    var locationSection = document.querySelector('[id$="__rich_text_Mmcj7K"]');
    if (!locationSection || locationSection.dataset.taHomeBranchTabs === 'ready') return;

    var blocks = locationSection.querySelector('.rich-text__blocks');
    if (!blocks) return;

    var branches = [
      {
        name: 'Sucursal Sur Xochimilco',
        address: 'Rincón Hacienda 17, Bosque del Sur, Xochimilco, 16010 Ciudad de México, CDMX'
      },
      {
        name: 'Sucursal Tlalnepantla',
        address: 'C. Agustín Melgar 23, Niños Héroes, 54017 Tlalnepantla, Méx.'
      }
    ];

    var tabsId = 'ta-home-branch-tabs-' + Math.random().toString(36).slice(2);
    var nav = branches.map(function (branch, index) {
      return '<button class="ta-home-branch-tabs__tab' + (index === 0 ? ' is-active' : '') + '" type="button" data-ta-branch-tab="' + index + '" aria-selected="' + (index === 0 ? 'true' : 'false') + '">' + esc(branch.name) + '</button>';
    }).join('');

    var panels = branches.map(function (branch, index) {
      var mapsUrl = makeMapsUrl(branch.address);
      var embedUrl = makeEmbedUrl(branch.address);
      return '<div class="ta-home-branch-tabs__panel' + (index === 0 ? ' is-active' : '') + '" data-ta-branch-panel="' + index + '">' +
        '<div class="ta-home-branch-tabs__card">' +
          '<div class="ta-home-branch-tabs__info">' +
            '<div>' +
              '<h3 class="ta-home-branch-tabs__name">' + esc(branch.name) + '</h3>' +
              '<p class="ta-home-branch-tabs__address">' + esc(branch.address) + '</p>' +
            '</div>' +
            '<a class="ta-home-branch-tabs__link" href="' + mapsUrl + '" target="_blank" rel="noopener">Abrir en Google Maps</a>' +
          '</div>' +
          '<iframe class="ta-home-branch-tabs__map" src="' + embedUrl + '" loading="lazy" allowfullscreen referrerpolicy="no-referrer-when-downgrade"></iframe>' +
        '</div>' +
      '</div>';
    }).join('');

    var wrapper = document.createElement('div');
    wrapper.className = 'ta-home-branch-tabs';
    wrapper.id = tabsId;
    wrapper.innerHTML = '<div class="ta-home-branch-tabs__nav" role="tablist">' + nav + '</div>' + panels;
    blocks.appendChild(wrapper);

    wrapper.addEventListener('click', function (event) {
      var button = event.target.closest('[data-ta-branch-tab]');
      if (!button) return;
      var index = button.getAttribute('data-ta-branch-tab');
      wrapper.querySelectorAll('[data-ta-branch-tab]').forEach(function (tab) {
        var active = tab.getAttribute('data-ta-branch-tab') === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      wrapper.querySelectorAll('[data-ta-branch-panel]').forEach(function (panel) {
        panel.classList.toggle('is-active', panel.getAttribute('data-ta-branch-panel') === index);
      });
    });

    locationSection.dataset.taHomeBranchTabs = 'ready';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHomeBranchTabs);
  } else {
    initHomeBranchTabs();
  }
  document.addEventListener('shopify:section:load', initHomeBranchTabs);
})();

/* V81 - Financiamiento: botón visible de v79 + salida directa a WhatsApp */
(function(){
  var url = 'https://wa.me/525527044169?text=Hola%20TodoAutomotriz%2C%20quiero%20comprar%20mi%20auto%20en%20meses';
  function bindFinanceWhatsapp(){
    document.querySelectorAll('[data-ta-financing-whatsapp="true"]').forEach(function(btn){
      if (btn.dataset.taWaDirectBound === '1') return;
      btn.dataset.taWaDirectBound = '1';
      btn.addEventListener('click', function(ev){
        ev.preventDefault();
        ev.stopPropagation();
        window.open(url, '_blank', 'noopener');
      }, true);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindFinanceWhatsapp);
  } else {
    bindFinanceWhatsapp();
  }
  document.addEventListener('shopify:section:load', bindFinanceWhatsapp);
})();

/* =========================================================
   V91 - Gestoría: mantener botón original visible y enviar a WhatsApp
   No cambia el link/render del botón en index.json ni el layout.
   Solo intercepta el click del botón CONTÁCTANOS de Gestoría.
   ========================================================= */
(function () {
  var WA_URL = 'https://wa.me/525527044169?text=Hola%20TodoAutomotriz%2C%20quiero%20informaci%C3%B3n%20sobre%20el%20servicio%20de%20gestor%C3%ADa';
  function norm(t) {
    return (t || '').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim();
  }
  function isGestoriaButton(el) {
    if (!el || !el.matches || !el.matches('a, button')) return false;
    var label = norm(el.innerText || el.textContent || el.getAttribute('aria-label') || '');
    if (label.indexOf('contactanos') === -1 && label.indexOf('contáctanos') === -1) return false;

    var container = el.closest('[id*="multirow_378MEQ"], .shopify-section, section, .multirow, .image-with-text');
    if (!container) return false;
    var txt = norm(container.innerText || container.textContent || '');
    return txt.indexOf('servicio de gestoria') !== -1 || txt.indexOf('contamos con servicio de gestoria') !== -1;
  }
  function bindGestoriaWhatsapp() {
    var links = document.querySelectorAll('a, button');
    links.forEach(function (el) {
      if (!isGestoriaButton(el)) return;
      if (el.dataset.taGestoriaWaBound === '1') return;
      el.dataset.taGestoriaWaBound = '1';
      el.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        window.open(WA_URL, '_blank', 'noopener');
      }, true);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindGestoriaWhatsapp);
  } else {
    bindGestoriaWhatsapp();
  }
  document.addEventListener('shopify:section:load', bindGestoriaWhatsapp);
  window.addEventListener('load', bindGestoriaWhatsapp);
  setTimeout(bindGestoriaWhatsapp, 300);
  setTimeout(bindGestoriaWhatsapp, 1000);
})();
